module.exports = __webpack_public_path__ + "img/HPB.ebb22906.svg";